import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery, Shadow, Transition } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const FeaturePresentation = styled.div`
  max-width: 1200px;
  margin: 0px auto 50px auto;

  ${MediaQuery.L_AND_DOWN} {
    max-width: none;
    margin: 0px 45px 100px 45px;
  }

  ${MediaQuery.M_AND_DOWN} {
    margin: 0px 45px 60px 45px;
  }

  ${MediaQuery.M_AND_DOWN} {
    margin: 0px 15px 60px 15px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;

  ${MediaQuery.L_AND_DOWN} {
    display: block;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  order: ${({ isReverse }) => (isReverse ? '1' : '0')};
  padding: 50px;
  width: 50%;

  p {
    margin: 30px 0;
  }

  ${MediaQuery.L_AND_DOWN} {
    margin: auto;
    width: initial;
    padding: 0px;
  }
`;

export const Title = styled.h2`
  ${Typography.XXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
`;

export const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin: -8px;

  ${MediaQuery.S_AND_DOWN} {
    justify-content: center;
  }
`;

export const FeatureCardWrapper = styled.a`
  cursor: pointer;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  width: 75px;
  height: 60px;
  padding: 8px;
  margin: 8px;
  text-align: center;
  background-color: ${Color.WHITE};
  box-shadow: ${Shadow.BOX};
  transition: ${Transition.ALL_EASE};
  text-decoration: none;
  box-sizing: border-box;

  img {
    margin-bottom: 10px;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${Shadow.BOX_ACTIVE};
  }
`;

export const FeatureName = styled.p`
  ${Typography.XS};
  font-size: 6px;
  margin: 0px !important;
  color: ${Color.DOLPHIN};
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  order: ${({ isReverse }) => (isReverse ? '0' : '1')};
  width: 50%;
  max-height: 500px;
  padding: 0 50px;

  ${MediaQuery.L_AND_DOWN} {
    margin-top: 20px;
    width: 100%;
    max-height: initial;
    padding: 0px;
  }
`;
